import { RootState } from "@app/store";
import { createSelector } from "@reduxjs/toolkit";

const selectUserState = (state: RootState) => state['user-slice']

export const selectAuth = createSelector(
    selectUserState,
    userSlice => userSlice.auth
)

export const selectUser = createSelector(
    selectUserState,
    userSlice => userSlice.user
)